import type { UploadChangeParam, UploadFile } from "antd/es/upload";

export const normFile = (e: UploadChangeParam<UploadFile>) => {
  if (Array.isArray(e)) {
    return e;
  }
  return e && e?.fileList;
};

export const getBase64 = (file: File) =>
  new Promise<string | ArrayBuffer | null>((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });

interface HierarchyItem {
  [key: string]: unknown;
  child?: HierarchyItem[];
}

interface HierarchyNode {
  title: unknown;
  value: unknown;
  children?: HierarchyNode[];
}

export const generateHierarchy = (
  items: HierarchyItem[],
  titleKey: string,
  valueKey = "_id",
): HierarchyNode[] => {
  if (items?.length > 0) {
    return items.map((item) =>
      item?.child && item.child.length > 0
        ? {
            title: item[titleKey],
            value: item[valueKey],
            children: generateHierarchy(item.child, titleKey, valueKey),
          }
        : {
            title: item[titleKey],
            value: item[valueKey],
          },
    );
  }
  return [];
};

export function slugify(text: string): string {
  return text
    .toString()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
}
